export const seriesId = [
  "pibpm",
  "vabpb_sndv",
  "pibpr",
  "c",
  "cp",
  "fbc",
  "fbcf",
  "ve",
  "exp",
  "imp",
  "imp_bienes",
  "imp_bienes_consumo",
  "imp_bienes_capital",
  "imp_bienes_intermedios",
  "PIBpmcorr",
  "k",
  "ppm",
  "pc",
  "pcp",
  "def_fbcf",
  "px",
  "pm",
  "p",
  "PFM",
  "yw",
  "n",
  "pa",
  "pob_mayor_16",
  "v",
  "ld",
  "ptetc",
  "ptetc_ld",
  "asa",
  "asatc",
  "ldg",
  "ldgbis",
  "tasa_paro",
  "ht",
  "w",
  "tp",
  "PIBpb",
  "e",
  "pe",
  "m1",
  "m3",
  "re",
  "reu",
  "er",
  "tc",
  "b",
  "activos_financieros_netos",
  "TR",
  "P11R",
  "P131R",
  "D2R",
  "D4R",
  "D5R",
  "D61R",
  "D7R",
  "D9R",
  "TE",
  "P2E",
  "P5E",
  "D1E",
  "D29E",
  "D3E",
  "D4E",
  "D_51p",
  "D62E",
  "D63PE",
  "D7E",
  "D9E",
  "K2E",
  "B9",
  "ayudas_entidades",
  "PDes",
  "kpublico"
]

export const seriesEsp = [
  "PRODUCTO INTERIOR BRUTO pm",
  "VAB de la rama Servicios No De Mercado",
  "PIB privado",
  "Gasto en consumo final de los hogares  y de las ISFSH",
  "Gasto en consumo final de las AAPP",
  "Formación bruta de capital",
  "Formación Bruta de Capital Fijo",
  "Variación de Existencias",
  "Exportación de bienes y servicios",
  "Importación de bienes y servicios",
  "Importación de bienes",
  "Importación de bienes de Consumo",
  "Importación de bienes de Capital",
  "Importación de bienes Intermedios",
  "PRODUCTO INTERIOR BRUTO pm (pr. corr.)",
  "Stock de Capital",
  "Deflactor PIBpm",
  "Deflactor del Gasto en consumo Final (Hogares + ISFSH)",
  "Deflactor del Gasto en Consumo Final de las AA.PP.",
  "Deflactor de la FBCF",
  "Deflactor de las exportaciones de bienes y servicios",
  "Deflactor de las importaciones de bienes y servicios",
  "Deflactor del PIB a precios básicos (2010=1)",
  "Precios exteriores",
  "PIB clientes Resto del Mundo",
  "Población",
  "Población activa",
  "Pobl. De 16 años o más",
  "Vacantes",
  "Ocupados",
  "Ocupados; puestos de trabajo equivalente a tiempo completo",
  "Ratio Puestos de trabajo equivalente a tiempo completo / Ocupados",
  "Asalariados",
  "Asalariados; puestos de trabajo equivalente a tiempo completo",
  "Ocupados servicios NO de mercado",
  "Ocupados servicios NO de mercado; puestos de trabajo equivalente a tiempo completo",
  "Tasa de paro",
  "Horas trabajadas",
  "Remuneración de asalariados total (p corrientes)",
  "Impuestos netos sobre los productos (P08)",
  "PIB privado a precios básicos",
  "Energía",
  "Indice del Precio de la energía",
  "Oferta monetaria España (M1)",
  "Oferta monetaria España (M3)",
  "Tipo de interés español a 3 meses",
  "Tipo de interés EEUU a 3 meses",
  "Tipo de cambio nominal",
  "Tipo de cambio nominal",
  "Deuda AAPP",
  "Activos financieros netos economia nacional",
  "TOTAL RECURSOS DE LAS AA.PP.",
  "Producción de mercado (P.11)",
  "Pagos por otra producción no de mercado (P.131)",
  "Impuestos sobre la producción y las importaciones (D.2)",
  "Rentas de la propiedad (D.4)",
  "Impuestos corrientes sobre la renta, el patrimonio, etc. (D.5)",
  "Cotizaciones sociales (D.61)",
  "Otras transferencias corrientes (D.7)",
  "Transferencias de capital (D.9)",
  "TOTAL EMPLEOS DE LAS AA.PP.",
  "Consumos intermedios (P.2)",
  "Formación bruta de capital (P.5)",
  "Remuneración de los asalariados (D.1)",
  "Otros impuestos sobre la producción (D.29)",
  "Subvenciones (D.3)",
  "Rentas de la propiedad (D.4)",
  "Impuestos corrientes sobre la renta…a pagar (D.51p)",
  "Prestaciones sociales distintas de las transferencias en especie (D.62)",
  "Transferencias sociales en especie relacionadas con el gasto en productos suministrados a los hogares  por productores de mercado (D.63p)",
  "Otras transferencias corrientes (D.7)",
  "Transferencias de capital (D.9)",
  "Adquisiciones menos cesiones de activos no financieros no producidos (K.2)",
  "CAPACIDAD (+) / NECESIDAD (-) DE FINANCIACIÓN",
  "Ayudas Entidades Financieras",
  "Prestaciones por desesmpleo",
  "Stock de capital publico"
]

export const seriesEng = [
  "Gross domestic product pm",
  "GVA non-market services",
  "GDP private",
  "Expenditure on final consumption of households and Current transfers to NPISHs",
  "Expenditure on final consumption of PA",
  "Gross capital formation",
  "Gross fixed capital formation",
  "Variation of existences",
  "Export of goods and services",
  "Import of goods and services",
  "Import of goods",
  "Import of consumer goods",
  "Import of capital goods",
  "Import of intermediate goods",
  "Gross domestic product pm (pr. corr.)",
  "Capital Stock",
  "GDPpm deflator",
  "Deflator of final consumption expenditure (Households + Current transfers to NPISHs)",
  "Deflator of final consumption expenditure of the PA",
  "GFCF deflator",
  "Deflator of exports of goods and services",
  "Deflator of imports of goods and services",
  "GDP deflator at basic prices (2010=1)",
  "Exterior prices",
  "GDP clients rest of the world",
  "Population",
  "Active population",
  "Population 16 years or older",
  "Unoccupied",
  "Employed",
  "Employed; full-time equivalent jobs",
  "Ratio of full-time equivalent jobs / Employed",
  "Employees",
  "Employees; full-time equivalent jobs",
  "Employees non-market services",
  "Employees NON-market services; full-time equivalent jobs",
  "Unemployment rate",
  "Hours worked",
  "Total compensation of employees (current p)",
  "Net taxes on products (P08)",
  "Private GDP at basic prices",
  "Energy",
  "Energy price index",
  "Money supply Spain (M1)",
  "Money supply Spain (M3)",
  "Spanish, Interest rate, 3-month",
  "USA, Interest rate, 3-month",
  "Nominal exchange rate",
  "Nominal exchange rate",
  "Government debt",
  "Net financial assets national economy",
  "TOTAL GOVERNMENT RESOURCES",
  "Market production (P.11)",
  "Payments for other non-market production (P.131)",
  "Taxes on production and imports(D.2)",
  "Property income (D.4)",
  "Current taxes on income, wealth, etc. (D.5)",
  "Social contributions (D.61)",
  "Other current transfers (D.7)",
  "Capital transfers (D.9)",
  "TOTAL PUBLIC EMPLOYMENTS",
  "Intermediate consumption (P.2)",
  "Gross capital formation (P.5)",
  "Compensation of employees (D.1)",
  "Other taxes on production (D.29)",
  "Grants (D.3)",
  "Property income (D.4)",
  "Current income taxes, payable (D.51p)",
  "Social benefits other than transfers in kind (D.62)",
  "Social transfers in kind related to spending on products supplied to households by market producers (D.63p)",
  "Other current transfers (D.7)",
  "Capital transfers (D.9)",
  "Acquisitions minus disposals of non-financial non-produced assets (K.2)",
  "Capacity (+) / Need (-) For Financing",
  "Financial Entities Aid",
  "Unemployment benefits",
  "Stock of public capital"
]

export const groupsEng = [
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Economy",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Deflators",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Population",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Energy",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration",
  "Public administration"
]

export const groupsEsp = [
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Economía",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Deflactores",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Población",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Energía",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública",
  "Administración pública"
]

export const unitsEsp = [
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € corr.",
  "mill. € cons.",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "Mill. €",
  "Miles personas",
  "Miles personas",
  "Miles personas",
  "personas",
  "Miles personas",
  "Miles personas",
  "",
  "Miles personas",
  "Miles personas",
  "Miles personas",
  "Miles personas",
  "%",
  "miles de horas",
  "mill. € corr.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "% var. 2010",
  "mill. € corr.",
  "mill. € corr.",
  "%",
  "%",
  "€ por $",
  "$ por €/ecu",
  "Mill. € corr",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €"
]

export const unitsEng = [
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € corr.",
  "mill. € cons.",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "% var. 2010",
  "Mill. €",
  "thousands of people",
  "thousands of people",
  "thousands of people",
  "personas",
  "thousands of people",
  "thousands of people",
  "",
  "thousands of people",
  "thousands of people",
  "thousands of people",
  "thousands of people",
  "%",
  "thousands of hours",
  "mill. € corr.",
  "mill. € cons.",
  "mill. € cons.",
  "mill. € cons.",
  "% var. 2010",
  "mill. € corr.",
  "mill. € corr.",
  "%",
  "%",
  "€ for $",
  "$ for €/ecu",
  "Mill. € corr",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €",
  "Mill. €"
]
